import { Confetti } from "../ui/Confetti";
import { IcoSave } from "../ui/icons";

export function PreviewDone({
  busy,
  onSave,
  onClose,
}: {
  busy: boolean;
  onSave: () => void;
  onClose: () => void;
}) {
  return (
    <div className="sg-bravo" role="dialog" aria-labelledby="sg-bravo-title">
      <Confetti />
      <div className="sg-bravo__card">
        <p className="sg-bravo__badge">Simulation OK</p>
        <h2 id="sg-bravo-title">Félicitations</h2>
        <p>Le parcours signataire fonctionne. Enregistrez le montage, ensuite on passera à la suite.</p>
        <div className="sg-bravo__acts">
          <button type="button" className="sg-btn" disabled={busy} onClick={onSave}>
            <IcoSave />
            {busy ? "Enregistrement…" : "Enregistrer"}
          </button>
          <button type="button" className="sg-btn ghost" onClick={onClose}>
            Revenir à l’édition
          </button>
        </div>
      </div>
    </div>
  );
}
